import Footer from "../components/templates/footer";
import Header from "../components/templates/navbar";
import "../assets/scss/pages/termsCondition.scss";

const TermsCondition = () => {
  return (
    // <div>
    //   <Header />
    //   <div className="terms-container">
    //     <h1>Terms and Conditions</h1>
    //     <p>
    //       Lorem ipsum dolor sit amet consectetur. Volutpat sagittis mattis sed
    //       tincidunt. Fermentum faucibus faucibus habitant diam ac. Viverra
    //       ullamcorper viverra urna quisque sed posuere. Bibendum viverra semper
    //       faucibus nec sit et et. Vitae pharetra et gravida facilisis. Ut in
    //       quam eget nec venenatis nec feugiat justo. Tincidunt ullamcorper
    //       sagittis dui scelerisque congue elementum ipsum.
    //     </p>

    //     <h2>Heading 2</h2>
    //     <p>
    //       Lorem ipsum dolor sit amet consectetur. Volutpat sagittis mattis sed
    //       tincidunt. Fermentum faucibus faucibus habitant diam ac. Viverra
    //       ullamcorper viverra urna quisque sed posuere. Bibendum viverra semper
    //       faucibus nec sit et et. Vitae pharetra et gravida facilisis. Ut in
    //       quam eget nec venenatis nec feugiat justo. Tincidunt ullamcorper
    //       sagittis dui scelerisque congue elementum ipsum.
    //     </p>

    //     <h3>Heading 3</h3>
    //     <p>
    //       Lorem ipsum dolor sit amet consectetur. Volutpat sagittis mattis sed
    //       tincidunt. Fermentum faucibus faucibus habitant diam ac. Viverra
    //       ullamcorper viverra urna quisque sed posuere. Bibendum viverra semper
    //       faucibus nec sit et et. Vitae pharetra et gravida facilisis. Ut in
    //       quam eget nec venenatis nec feugiat justo. Tincidunt ullamcorper
    //       sagittis dui scelerisque congue elementum ipsum.
    //     </p>

    //     <h4>Heading 4</h4>
    //     <p>
    //       Lorem ipsum dolor sit amet consectetur. Volutpat sagittis mattis sed
    //       tincidunt. Fermentum faucibus faucibus habitant diam ac. Viverra
    //       ullamcorper viverra urna quisque sed posuere. Bibendum viverra semper
    //       faucibus nec sit et et. Vitae pharetra et gravida facilisis. Ut in
    //       quam eget nec venenatis nec feugiat justo. Tincidunt ullamcorper
    //       sagittis dui scelerisque congue elementum ipsum.
    //     </p>

    //     <ul>
    //       <li>Lorem ipsum dolor sit amet consectetur.</li>
    //       <li>Lorem ipsum dolor sit amet consectetur.</li>
    //     </ul>

    //     <p>
    //       Lorem ipsum dolor sit amet <a href="#">consectetur</a>. Volutpat
    //       sagittis mattis sed tincidunt. Fermentum faucibus faucibus habitant
    //       diam ac. Viverra ullamcorper viverra urna quisque sed posuere.
    //       Bibendum viverra semper faucibus nec sit et et. Vitae pharetra et
    //       gravida facilisis. Ut in quam eget nec venenatis nec feugiat justo.
    //       Tincidunt ullamcorper sagittis dui scelerisque congue elementum ipsum.
    //     </p>
    //   </div>
    //   <Footer />
    // </div>
    <div>
      <Header />
      <div className="terms-container">
        <h1>Terms of Use</h1>
        {/* <p>Last updated: January 9, 2025</p> */}
        <p>
          These Terms of Use ("Terms") describe your rights and obligations
          while using the Resumly.AI website, software, services, and other
          offerings (collectively, "Services"). These Terms, together with our
          Privacy Policy, constitute an agreement between the user ("you") and
          Resumly.AI ("we," "us," "our").
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using our Services, you acknowledge that you have
          read, understood, and agree to be bound by these Terms. IF YOU DO NOT
          AGREE TO THESE TERMS, YOU MAY NOT ACCESS OR USE OUR SERVICES.
        </p>

        <h2>2. Privacy</h2>
        <p>
          Our collection, use, and disclosure of personal information are
          governed by our Privacy Policy, available at:{" "}
          <a href="https://www.resumly.ai/privacy">
            https://www.resumly.ai/privacy
          </a>
          .
        </p>

        <h2>3. User Account Registration</h2>
        <p>
          Certain features of our Services may require you to create an account
          ("User Account"). You agree to provide accurate, current, and complete
          information during registration and to maintain the confidentiality of
          your account credentials.
        </p>

        <h2>4. Use of Services</h2>
        <p>
          You agree to use our Services only as permitted by these Terms and
          applicable laws. Prohibited uses include, but are not limited to:
        </p>
        <ul>
          <li>Violating any applicable laws or regulations.</li>
          <li>
            Using automated tools such as bots or scrapers without prior
            consent.
          </li>
          <li>
            Interfering with the security or proper functioning of the Services.
          </li>
          <li>
            Copying, reproducing, or redistributing the Services or their
            content without permission.
          </li>
          <li>
            Posting, distributing, or transmitting unlawful, infringing, or
            harmful content.
          </li>
        </ul>

        <h2>5. Suspension and Termination of Access</h2>
        <p>
          We may suspend or terminate your access to the Services if required by
          law or if you engage in prohibited activities. Decisions to suspend or
          terminate access may involve confidential criteria essential to our
          risk management.
        </p>

        <h2>6. Intellectual Property</h2>
        <p>
          All content and functionality of the Services, including text, images,
          videos, and software (collectively, "Content"), are owned by
          Resumly.AI or its licensors and are protected by copyright, trademark,
          and other laws.
        </p>

        <h2>7. Subscriptions</h2>
        <p>
          Your subscription will renew automatically unless canceled before the
          renewal date. Subscription fees are non-refundable. Resumly.AI
          reserves the right to change subscription pricing with at least 30
          days' notice.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          TO THE FULLEST EXTENT PERMITTED BY LAW, RESUMLY.AI IS NOT LIABLE FOR
          INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES
          ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICES.
        </p>

        <h2>9. Indemnity</h2>
        <p>
          You agree to indemnify and hold harmless Resumly.AI and its
          affiliates, officers, and employees from any claims or damages arising
          out of your use of the Services, violation of these Terms, or
          infringement of any rights of a third party.
        </p>

        <h2>10. Early-Stage Service</h2>
        <p>
          Our Services are in early stages of development and may experience
          stability issues or downtime. Services are provided "as is," without
          warranties of any kind.
        </p>

        <h2>11. Dispute Resolution</h2>
        <p>
          <strong>a. Governing Law:</strong> These Terms are governed by the
          laws of Ontario, Canada.
        </p>
        <p>
          <strong>b. Mandatory Arbitration:</strong> All disputes arising out of
          or related to these Terms shall be resolved through confidential
          arbitration in Toronto, Canada.
        </p>
        <p>
          <strong>c. No Class Actions:</strong> Disputes must be resolved on an
          individual basis; class actions are not permitted.
        </p>

        <h2>12. External Links</h2>
        <p>
          Our Services may contain links to third-party websites. We are not
          responsible for the content, terms, or practices of such websites.
        </p>

        <h2>13. Severability</h2>
        <p>
          If any provision of these Terms is deemed invalid, the remaining
          provisions will remain in full force.
        </p>

        <h2>14. Entire Agreement</h2>
        <p>
          These Terms and our Privacy Policy constitute the entire agreement
          between you and Resumly.AI regarding the use of our Services.
        </p>

        <h2>15. Contact Information</h2>
        <p>
          If you have any questions about these Terms, please contact us at{" "}
          <a href="mailto:hello@resumly.ai">hello@resumly.ai</a>.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default TermsCondition;
